import css from './index.module.scss';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import { useGlobal } from '@/utils/useGlobal';
import GroupcA from './groupcA';

gsap.registerPlugin(ScrollTrigger);
export default function Comp({}: any) {
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    const startNumScale = 1.3;
    const { useEffect } = useGlobal();

    useEffect(() => {
        const gsapdGroupdA1 = gsap.timeline({
            scrollTrigger: {
                trigger: '#gsapdGroupd-trigger-1',
                //scrub: true,
                start: `${layoutH * startNumScale} bottom`,
                end: `+=${layoutH * 0.5}`,
                toggleActions: 'play none none reverse',
            },
        });
        gsapdGroupdA1
            .fromTo(
                '.gsapdGroupd .gsapdGroupA .a-msg-box-a',
                {
                    opacity: 1,
                    y: 0,
                },
                {
                    opacity: 0,
                    y: -40,
                    duration: 0.3,
                    ease: 'none',
                },
            )
            .to('.gsapdGroupd .gsapdGroupA .a-msg-box-b', {
                opacity: 1,
                duration: 0.3,
                ease: 'none',
            });

        gsapdGroupdA1.scrollTrigger.refresh();
    }, []);
    return (
        <>
            <div id="gsapdGroupd-trigger-1"></div>
            <div className={`${css.gsapdGroupd} gsapdGroupd`}>
                <div className="ef-scroll-ani-total-box">
                    <div className="ef-scroll-ani">
                        <div className="ef-scroll-ani-trigger">
                            <div className="ef-scroll-ani-inter">
                                <GroupcA />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
